// 🏆 Rhythm Rally Achievement Definitions
// These auto-sync to Firebase when the game loads

import { AchievementDefinition } from '../services/GameAPI';

export const RHYTHM_RALLY_ACHIEVEMENTS: AchievementDefinition[] = [
  {
    id: "level_1",
    gameId: "rhythm-rally",
    title: "First Steps",
    description: "Complete your first level in Rhythm Rally! You're on your way to becoming a rhythm master.",
    iconUrl: "🎵",
    museCashReward: 25,
    type: "milestone",
    rarity: "common",
    implemented: true,
    sortOrder: 1,
    category: "progression"
  },
  {
    id: "level_2", 
    gameId: "rhythm-rally",
    title: "Getting the Hang of It",
    description: "Reach level 2! Your rhythm skills are improving with every beat.",
    iconUrl: "🎶",
    museCashReward: 50,
    type: "milestone",
    rarity: "common", 
    implemented: true,
    sortOrder: 2,
    category: "progression"
  },
  {
    id: "level_5",
    gameId: "rhythm-rally", 
    title: "Rhythm Rookie",
    description: "Achieve level 5! You've proven you can keep up with the beat consistently.",
    iconUrl: "🥁",
    museCashReward: 100,
    type: "milestone",
    rarity: "common",
    implemented: true,
    sortOrder: 3,
    category: "progression"
  },
  {
    id: "level_10",
    gameId: "rhythm-rally",
    title: "Beat Master", 
    description: "Reach level 10! Your timing is getting impressive - few players make it this far.",
    iconUrl: "🎯",
    museCashReward: 200,
    type: "milestone",
    rarity: "rare",
    implemented: true,
    sortOrder: 4,
    category: "progression"
  },
  {
    id: "level_20",
    gameId: "rhythm-rally",
    title: "Rhythm Veteran",
    description: "Level 20 conquered! You've developed serious rhythm skills and dedication.",
    iconUrl: "🏅",
    museCashReward: 500,
    type: "milestone", 
    rarity: "rare",
    implemented: true,
    sortOrder: 5,
    category: "progression"
  },
  {
    id: "level_50",
    gameId: "rhythm-rally",
    title: "Tempo Legend",
    description: "Incredible! Level 50 reached. You're among the elite rhythm masters.",
    iconUrl: "👑",
    museCashReward: 1000,
    type: "milestone",
    rarity: "epic",
    implemented: true,
    sortOrder: 6,
    category: "progression"
  },
  {
    id: "level_100", 
    gameId: "rhythm-rally",
    title: "Rhythm Rally Champion",
    description: "LEGENDARY! Level 100 achieved. You are the ultimate Rhythm Rally champion!",
    iconUrl: "🏆",
    museCashReward: 2500,
    type: "milestone",
    rarity: "legendary",
    implemented: true,
    sortOrder: 7,
    category: "progression"
  }
]; 